import styled from "@emotion/styled";

import Left from './left.png';
import Middle from './middle.png';
import Right from './right.png';

const mobileWidth = `768px`;

export const Button = styled.button`
position: relative;
height: 64px;
box-shadow: 0px 20px 32px rgba(63, 101, 97, 0.5);
color: #000;
border: none;
padding: 0;
margin: 0;

text-transform: uppercase;
font-weight: 700;
font-size: 24px;
line-height: 24px;

background-repeat: repeat-x;
display: flex;
align-items: center;
justify-content: center;
white-space: nowrap;

cursor: pointer;
gap: 12px;
svg {
  max-width: 32px;
}

&::before,
&::after {
  content: '';
  display: block;
  position: absolute;
  height: 64px;
  width: 48px;
  top: 0;
}

&::before {
  left: -48px;
}
&::after {
  right: -48px;
}

@media screen and (max-width: ${mobileWidth}) {
  font-size: 20px;
  line-height: 24px;
  white-space: normal;
}

color: #e60000;
background-image: url(${Middle});

&::before {
  background-image: url(${Left});
  background-repeat: no-repeat;
}
&::after {
    background-image: url(${Right});
    background-repeat: no-repeat;
}


&[disabled] {
  pointer-events: none;
  opacity: 0.3;
`